module.exports = __webpack_public_path__ + "Images/layout_white.png";


//////////////////
// WEBPACK FOOTER
// ./Images/layout_white.png
// module id = 811
// module chunks = 2